<template>

    <v-page-body>
        <v-section-basic-info />
        <v-section-change-password />
        <v-section-2fa />
        <v-section-delete-account />
    </v-page-body>

</template>

<script>

import Section2FA from './components/Section2FA';
import SectionBasicInfo from './components/SectionBasicInfo';
import SectionChangePassword from './components/SectionChangePassword';
import SectionDeleteAccount from './components/SectionDeleteAccount';
import UserApi from '@api/UserApi';

export default {

    components: {
        'v-section-2fa': Section2FA,
        'v-section-basic-info': SectionBasicInfo,
        'v-section-change-password': SectionChangePassword,
        'v-section-delete-account': SectionDeleteAccount,
    },

    data() {
        return {
            user: null,
        }
    },

    mounted() {
        this.getUser();
    },

    methods: {

        getUser() {
            this.$store.commit('loading', true);
            UserApi.getUser()
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.user = response.data.data;
                    this.$events.$emit('pageLoaded');
                }, () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

    },

}

</script>
